import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import languageReducer from '../language/slice';

export const store = configureStore({
  reducer: {
    languageStore: languageReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
